import Spinner from './Spinner'

export default function StatusBubble({ label }: { label: string }) {
  return (
    <div className="inline-flex items-center gap-1.5 self-start px-1 py-0.5 text-[11px] text-stone-400">
      <Spinner />
      {label}
    </div>
  )
}
